// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.
import { SmartTable } from '../../../components/smart-table/smart-table.model';
import {
    loginPointLabel,
    loginPoints
} from '../../../components/sp-login-point/sp-login-point.enum';
import { loginTypeLabel, loginTypes } from '../../../components/sp-login-type/sp-login-type.enum';

/** @ngInject */
export function Controller($scope) {
    this.$onInit = () => {
        this.loginTypes = loginTypes;
        this.loginPoints = loginPoints;
        this.loginTypeLabel = loginTypeLabel;
        this.loginPointLabel = loginPointLabel;

        const logs = this.logs;
        const format = date => new Date(date).toString().slice(4, 24);
        logs.forEach(log => log.loggedInOnDisplay = format(log.loggedInOn));
    $scope.st = new SmartTable();

    $scope.isHardTokenUser = this.account.isSecondaryDeviceSession;
    $scope.datepickerOptions = {maxDate: new Date()};
    $scope.startDate = null;
    $scope.endDate = null;

    $scope.getLoginSourceTooltip = function(log) {
        const {loginClient, loginClientOs, loginIp} = log;
        return [loginClient, loginClientOs, loginIp && `IP: ${loginIp}`].filter($ => $).join(' - ');
    }

    $scope.getLoginToTooltip = function(log) {
        const {loginService, appType, username} = log;
        return [loginService, appType, username].filter($ => $).join(' - ');
    }

    $scope.filterByDate = () => {
        const endDate = new Date(+$scope.endDate + 24 * 60 * 60 * 1000);
        const afterStart = log => $scope.startDate ? log.loggedInOn > $scope.startDate : true;
        const beforeEnd = log => $scope.endDate ? log.loggedInOn < endDate : true;
        this.logs = logs.filter(log => afterStart(log) && beforeEnd(log));
    }

    $scope.open = function($event, type) {
        $event.preventDefault();
        $event.stopPropagation();
        if (type == 1) {
            $scope.opened = true;
            $scope.opened1 = false;
        } else {
            $scope.opened1 = true;
            $scope.opened = false;
        }
    };
    // show-hide search button on (login-to) input field
    $(function() {
        $(".sp_filterSearchLoginTo").keyup(function() {
            var myLength = $(".sp_filterSearchLoginTo").val().length;
            if (myLength >= 1) {
                $(".sp_filterSearchLoginToSpan").hide();
            } else {
                $(".sp_filterSearchLoginToSpan").show();
            }
        });
    });

    $scope.export = {
        template: 'statistics',
        name: 'SAASPASS_Statistics',
        fields: ['username','loginType', 'loginPoint', 'loginService', 'sucessfulLogin', 'loginIp', 'loggedInOnDisplay']
    };
    };
}



// WEBPACK FOOTER //
// ./src/portal/states/user/statistics/statistics.controller.js